import { Box, Link, Typography, useTheme } from "@mui/material";

type ItemContactProps = {
  icon: React.ReactNode;
  title: string;
  href?: string;
  labelLink?: string;
  label?: string;
  notTarget?: boolean;
};
export const ItemContact = ({
  icon,
  title,
  href,
  labelLink,
  label,
  notTarget,
}: ItemContactProps) => {
  const theme = useTheme();
  return (
    <Box display="flex" gap={3}>
      {icon}
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography sx={{ color: theme.palette.secondary.main }} variant="h6">
          {title}
        </Typography>
        {labelLink ? (
          <Link
            href={href}
            variant="body2"
            sx={{
              fontWeight: 400,
              textDecoration: "none",
              transition: "color 0.3s ease",
              color: theme.palette.secondary[100],
              "&:hover": {color: theme.palette.primary[500]}
            }}
            target={notTarget ? "" : "_blank"}
          >
            {labelLink}
          </Link>
        ) : (
          <Typography
            variant="body2"
            sx={{
              fontWeight: 400,
              textDecoration: "none",
              color: theme.palette.secondary[100],
            }}
          >
            {label}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
